import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SharedDialogsModule } from '../shared-dialogs.module';

import { ToastComponent } from './toast.component';
import { ToastSuccessComponent } from './toast-success.component';
import { ToastSuccessToSteamComponent } from './toast-success-to-steam.component';
import { ToastSuccessFromSteamComponent } from './toast-success-from-steam.component';
import { ToastErrorFromSteamComponent } from './toast-error-from-steam.component';
import { ToastTakingFromSteamComponent } from './toast-taking-from-steam.component';
import { ToastTransferingToSteamComponent } from './toast-transfering-to-steam.component';
import { ToastTransferingPixelComponent } from './toast-transfering-pixel.component';
import { ToastTransferingCpuUnlockComponent } from './toast-transfering-cpu-unlock.component';
import { ToastTransferingAccessKeyComponent } from './toast-transfering-access-key.component';
import { ToastDecorationsDeactivatedComponent } from './toast-decorations-deactivated.component';
import { ToastUnderDevelopmentComponent } from './toast-under-development.component';
import { ToastSuccessPixelComponent } from './toast-success-pixel.component';
import { ToastSuccessAccessKeyComponent } from './toast-success-access-key.component';
import { ToastSuccessCpuUnlockComponent } from './toast-success-cpu-unlock.component';

import { ToastrRef } from './toastr.ref';
export { ToastRef } from './toast-ref';

import { ToastrService, TOAST_DATA } from './toastr.service';
export { ToastrService, TOAST_DATA } from './toastr.service';

@NgModule({
    imports: [
        CommonModule,
        MatFormFieldModule,

        SharedDialogsModule
    ],
    declarations: [
        ToastComponent,

        ToastSuccessComponent,
        ToastSuccessToSteamComponent,
        ToastSuccessFromSteamComponent,
        ToastErrorFromSteamComponent,
        ToastTakingFromSteamComponent,
        ToastTransferingToSteamComponent,
        ToastTransferingPixelComponent,
        ToastTransferingCpuUnlockComponent,
        ToastTransferingAccessKeyComponent,
        ToastDecorationsDeactivatedComponent,
        ToastUnderDevelopmentComponent,
        ToastSuccessPixelComponent,
        ToastSuccessAccessKeyComponent,
        ToastSuccessCpuUnlockComponent
    ],
    exports: [
        ToastComponent,

        ToastSuccessComponent,
        ToastSuccessToSteamComponent,
        ToastSuccessFromSteamComponent,
        ToastErrorFromSteamComponent,
        ToastTakingFromSteamComponent,
        ToastTransferingToSteamComponent,
        ToastTransferingPixelComponent,
        ToastTransferingCpuUnlockComponent,
        ToastTransferingAccessKeyComponent,
        ToastDecorationsDeactivatedComponent,
        ToastUnderDevelopmentComponent,
        ToastSuccessPixelComponent,
        ToastSuccessAccessKeyComponent,
        ToastSuccessCpuUnlockComponent
    ],
    entryComponents: [
        ToastComponent,

        ToastSuccessComponent,
        ToastSuccessToSteamComponent,
        ToastSuccessFromSteamComponent,
        ToastErrorFromSteamComponent,
        ToastTakingFromSteamComponent,
        ToastTransferingToSteamComponent,
        ToastTransferingPixelComponent,
        ToastTransferingCpuUnlockComponent,
        ToastTransferingAccessKeyComponent,
        ToastDecorationsDeactivatedComponent,
        ToastUnderDevelopmentComponent,
        ToastSuccessPixelComponent,
        ToastSuccessAccessKeyComponent,
        ToastSuccessCpuUnlockComponent
    ],
    providers: [
        ToastrRef,
        ToastrService
    ]
})
export class ToastrModule {
    constructor(
        ref: ToastrRef
    ) {
    }
}
